import { AUTH_STORAGE_KEY } from './auth-store';

export function clearLegacyAuthStorage(): void {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
  } catch {
    // localStorage bloqueado (e.g. Safari modo privado) — ignorar
  }
}
